import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Grid} from "@mui/material";

// Components
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";

// Utils
import {getTranslation} from "domain/helpers/translations";

RetailerNameDrawerTitle.propTypes = {
    wmsItems: PropTypes.array.isRequired,
};

function RetailerNameDrawerTitle({ wmsItems }) {
    const [retailer, setRetailer] = useState(null);

    useEffect(() => {
        function getRetailerFromWmsItem(items) {
            if (items.length > 0 && items[0].lineItem.retailer) {
                return items[0].lineItem.retailer;
            }
            return null;
        }

        setRetailer(getRetailerFromWmsItem(wmsItems));
    }, [wmsItems]);

    if (!retailer) {
        return ''
    }

    return (
        <Grid
            container
            style={{
                alignItems: 'center',
                marginRight: '16px',
                flexWrap: 'nowrap',
                maxWidth: '70%'
            }}
        >
            <Grid item>
                <ThumbnailAndNotification link={getTranslation(retailer)?.logo?.contentUrl || ""} />
            </Grid>
            <Grid
                item
                style={{ marginLeft:'16px' }}
            >
                {retailer.name}
            </Grid>
        </Grid>
    )
}

export default RetailerNameDrawerTitle;
